// extracted by mini-css-extract-plugin
module.exports = {"contactContent":"Contact_contactContent__8IVwn","padding":"Contact_padding__3NNrJ","googlemap":"Contact_googlemap__1HwVJ","link":"Contact_link__3ACJ3"};